import React, { useState } from 'react';
import Modal from "../Modal/Modal";
import warningGif from "../../assets/gif/expired.gif";
import axios from "axios";
import { BASE_URL } from "../../utils/Element";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../redux/Action/AuthActions";
import { NotificationManager } from "react-notifications";
import Loader from "../Loader";

const SessionExpiredModal = ({ showSessionExpired, handleLogOut, onClose }) => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails);
  const [loading, setLoading] = useState(false);

  const handleRefreshSession = () => {
    if (!userDetails?.email) {
      NotificationManager.error("User email not found. Please login again.");
      handleLogOut();
      return;
    }

    setLoading(true);
    axios.post(`${BASE_URL}/re-create-session`, { email: userDetails.email })
      .then((res) => {
        setLoading(false);
        const data = res?.data?.data;
        if (data?.token) {
          dispatch(setToken(data.token));
          onClose(); // Hide modal
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.data?.message) {
          NotificationManager.error(err.response?.data?.message);
        } else {
          NotificationManager.error("Failed to refresh session.");
        }
      });
  };

  return (
    <>
      {loading && <Loader />}
      <Modal width="450px" show={showSessionExpired} onClose={onClose}>
      <div className="py-3 text-center">
        <div className="flex justify-center mt-[-20px]">
          <img src={warningGif} alt="warning img" height={120} width={120} />
        </div>

        <div className="flex-1 mt-4 text-center w-30">
          <p className="head-1 dark-H font-bold">
            Session Expired
          </p>

          <p className="py-1 dark-M body-L">
            Your session has expired. Please login again to continue.
          </p>
        </div>

        <div className="mt-6 flex justify-center items-center gap-4">
          <button
            type="button"
            disabled={loading}
            onClick={handleRefreshSession}
            className="save-button light-L head-5 green-bg-H px-[20px] py-[12px]"
            style={{ opacity: loading ? 0.5 : 1 }}
          >
            {loading ? "Refreshing..." : "Refresh Session"}
          </button>

          <button
            type="button"
            onClick={handleLogOut}
            className="save-button dark-H head-5 bg-gray-200 hover:bg-gray-300 px-[20px] py-[12px] transition-colors"
          >
            Login Again
          </button>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default SessionExpiredModal;
